
import { getDetailStation } from "@/service/station.service";
import { isTextMeasurement } from "@/service/datastation.service";
import StationDetailComponent from "@/components/stations/StationDetail.component.vue";
import StationDataComponent from "@/components/stations/StationData.component.vue";
import StationChartNewComponent from "@/components/stations/StationChartNew.component.vue";
import { defineComponent } from "vue";
import { Station } from "@/types/station.type";
import { dateFormat } from "@/utils/date.utils";
import { Image } from "@/types";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import NoDataComponent from "@/components/NoData.component.vue";

export default defineComponent({
  components: {
    StationDetailComponent,
    StationDataComponent,
    StationChartNewComponent,
    NoDataComponent,
  },
  setup() {
    const store = useStore<RootState>();
    return { dateFormat, store };
  },
  data() {
    return {
      station: {} as Station,
      lastImage: {} as Image | undefined,
      station_id: this.$route.params.stationid,
      station_name: this.$route.query.stationname,
      date: new Date(),
      time: new Date(),
      parameter: "" as string,
      measurement: "" as string,
      type: "" as string,
    };
  },

  async mounted() {
    this.station = await getDetailStation(this.station_id as string);
    this.date = this.station.last_data_date as Date;
    this.time = this.station.last_data_time as Date;
    this.store.commit("station/setStation", this.station);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    formatDate(date: string) {
      if (date !== " ") {
        const newDate = new Date(date);
        date = newDate.toLocaleString();
      } else {
        date = "-";
      }
      return date;
    },
    changeParameter(parameter: string, measurement: string, type: string) {
      if (parameter !== "gps" && parameter !== "angle") {
        this.parameter = parameter;
        this.measurement = measurement;
        this.type = type;
      }
      return parameter;
    },
    notGraphable(measurement: string): boolean {
      return isTextMeasurement(measurement);
    },
  },
});
